/* eslint-disable array-callback-return */
/* eslint-disable no-self-assign */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Component } from "react";
import Select2 from "../select2";
import Select2multiple from "../select2/multiple";
import TimepickerLayer from "../TimePickerLayer";
import CheckboxLayer from "../CheckboxLayer";
import Inputlayer from "../Input";
import Tableantd3 from "../Table/Tableantd3";
import InputNumberlayer from "../InputNumberlayer";
import InputRadiolayer from "../InputradioLayer";
class QueuesListFormComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
      Queuedata: [],
      changedObj: {},
    };
  }
  // componentDidMount() {
  //   console.log("form", this.props);
  // }

  // componentDidUpdate(prevProps, prevState) {
  //     let { table_body } = this.state
  //     console.log('update:', this.props.Queuedata)
  //     if (prevProps.Queuedata.length == this.state.Queuedata.length) {

  //         this.setState((state) => ({ 'Queuedata': this.props.Queuedata, }))

  //     }
  // }
  selectChanges(event) {
    if (event.type && (event.type === "blur" || event.type === "enter")) {
      this.setState((state) => ({ changedObj: event }));
      this.props.onChange(event);
    } else {
      this.setState((state) => ({ changedObj: event }));
      this.props.onChange(event);
    }
  }
  handleChange(data) {
    console.log(data);
  }

  table_body_change(data, body) {
    data["feilds"] = body;

    this.props.add_more_event(data);
  }

  renderInput(data, key) {
    // console.log("data QueuesListFormComponent", data);
    let { id, slug } = this.props.match.params;
    if (data.mode === "single") {
      data["parrentMode"] = data.mode;
      data["parrentName"] = data.name;
      if (data.type === "select2" && data.visiable) {
        if (data.readonly) {
          return (
            <div class="row my-4 w-100">
              <div class="col">
                {id + "/" + slug === "queue/add" && <label>{data.label}</label>}
                {id + "/" + slug === "queue/view" && (
                  <label>{data.label}</label>
                )}
                {id + "/" + slug === "queue/edit" && (
                  <label>{data.label}</label>
                )}
                <p className="form-control mb-0 readonly">{data.text}</p>
              </div>
            </div>
          );
        } else {
          return (
            <div
              className={`${
                data.styles
                  ? data.styles.cols
                    ? data.styles.cols
                    : "row my-4 w-100"
                  : "row my-4 w-100"
              }`}
            >
              {id + "/" + slug === "queue/add" && <label>{data.label}</label>}
              {id + "/" + slug === "queue/view" && <label>{data.label}</label>}
              {id + "/" + slug === "queue/edit" && <label>{data.label}</label>}
              <Select2
                key={data.name}
                selectdata={data}
                {...this.props}
                {...this.state}
                Queuedata={this.props.Queuedata}
                onselectChanges={this.selectChanges.bind(this)}
              />
              {data.errors.map((err, key) => {
                return (
                  <small className="text-danger" key={key}>
                    {err.message}
                  </small>
                );
              })}
            </div>
          );
        }
      }
      if (data.type === "Select2multiple") {
      
        if (data.readonly) {
          return (
            <React.Fragment>
              <div class="row my-4 w-100">
                <div class="col">
                  {id + "/" + slug === "queue/add" && (
                    <label>{data.label}</label>
                  )}
                  {id + "/" + slug === "queue/view" && (
                    <label>{data.label}</label>
                  )}
                  {id + "/" + slug === "queue/edit" && (
                    <label>{data.label}</label>
                  )}
                  <p className="form-control mb-0 readonly">
                    {data.value.map((value, key) => {
                      return value.dc_name + ", ";
                    })}
                  </p>
                </div>
              </div>
            </React.Fragment>
          );
        } else {
          return (
            <div className="row my-4 w-100">
              {id + "/" + slug === "queue/add" && <label>{data.label}</label>}
              {id + "/" + slug === "queue/view" && <label>{data.label}</label>}
              {id + "/" + slug === "queue/edit" && <label>{data.label}</label>}
              <Select2multiple
                Queuedata={this.props.Queuedata}
                selectdata={data}
                {...this.props}
                {...this.state}
                onselectChanges={this.selectChanges.bind(this)}
              />
              {data.errors.map((err, key) => {
                return (
                  <small className="text-danger" key={key}>
                    {err.message}
                  </small>
                );
              })}
            </div>
          );
        }
      }
      if (data.type === "inputNumber") {
        if (data.readonly) {
          return (
            <div class="form-row my-4 w-100">
              <div class="col">
                {id + "/" + slug === "queue/add" && <label>{data.label}</label>}
                {id + "/" + slug === "queue/view" && (
                  <label>{data.label}</label>
                )}
                {id + "/" + slug === "queue/edit" && (
                  <label>{data.label}</label>
                )}
                <p className="form-control mb-0 readonly">{data.value}</p>
              </div>
            </div>
          );
        } else {
          return (
            <React.Fragment>
              {/* {id + "/" + slug !== "queue/add" && ( */}
              <div
                className={`${
                  data.styles
                    ? data.styles.cols
                      ? data.styles.cols
                      : "row my-4 w-100"
                    : "row my-4 w-100"
                }`}
              >
                {id + "/" + slug === "queue/add" && <label>{data.label}</label>}
                {id + "/" + slug === "queue/view" && (
                  <label>{data.label}</label>
                )}
                {id + "/" + slug === "queue/edit" && (
                  <label>{data.label}</label>
                )}
                <InputNumberlayer
                  key={data.name}
                  selectdata={data}
                  {...this.props}
                  {...this.state}
                  onselectChanges={this.selectChanges.bind(this)}
                />
              </div>
              {/* )} */}
            </React.Fragment>
          );
        }
      }
      if (data.type === "input" && data.visiable) {
        if (data.readonly) {
          return (
            <div class="form-row my-4 w-100">
              <div class="col">
                {id + "/" + slug === "queue/add" && <label>{data.label}</label>}
                {id + "/" + slug === "queue/view" && (
                  <label>{data.label}</label>
                )}
                {id + "/" + slug === "queue/edit" && (
                  <label>{data.label}</label>
                )}
                <p className="form-control mb-0 readonly">{data.value}</p>
              </div>
            </div>
          );
        } else {
          return (
            <React.Fragment>
              <div
                className={`${
                  data.styles
                    ? data.styles.cols
                      ? data.styles.cols
                      : "row my-4 w-100"
                    : "row my-4 w-100"
                }`}
              >
                {id + "/" + slug === "queue/add" && <label>{data.label}</label>}
                {id + "/" + slug === "queue/view" && (
                  <label>{data.label}</label>
                )}
                {id + "/" + slug === "queue/edit" && (
                  <label>{data.label}</label>
                )}
                <Inputlayer
                  {...this.props}
                  {...this.state}
                  key={key}
                  feildData={data}
                  onInputChanges={this.selectChanges.bind(this)}
                />
              </div>
            </React.Fragment>
          );
        }
      }
      if (data.type === "inputRadio") {
        return (
          <React.Fragment>
            <div
              className={`${
                data.styles
                  ? data.styles.cols
                    ? data.styles.cols
                    : "row my-4 w-100"
                  : "row my-4 w-100"
              }`}
            >
              <Inputlayer
                key={data.name}
                selectdata={data}
                {...this.props}
                {...this.state}
                onselectChanges={this.selectChanges.bind(this)}
              />
            </div>
          </React.Fragment>
        );
      }
    }
    if (data.mode === "table" && data.type === "table" && data.rowfeilds) {
      return (
        <React.Fragment>
          {data["rowfeilds"]["visible"] && (
            <React.Fragment key={key}>
              <div className="d-inline-flex pl-5 w-100">
                <h4 className="data-label w-100" style={{ fontSize: 20 }}>
                  {data["rowfeilds"].title ? data["rowfeilds"]["title"] : ""}
                </h4>
              </div>
              <div className="financial-table table-responsive">
                <Tableantd3
                  {...this.props}
                  {...this.state}
                  table_data={data["rowfeilds"]}
                  addon_feild={data["rowfeilds"].add_more_feilds}
                  onChange={this.selectChanges.bind(this)}
                  table_body_change={this.table_body_change.bind(this, {
                    parrent_name: data.name,
                  })}
                />
              </div>
            </React.Fragment>
          )}
        </React.Fragment>
      );
    }

    if (data.mode === "group" && data.type === "checkbox" && data.visiable) {
      return (
        <React.Fragment>
          <div
            className={`${
              data.styles
                ? data.styles.cols
                  ? data.styles.cols
                  : "row my-4 w-100"
                : "row my-4 w-100"
            }`}
          >
            <div className="col-12">
              <div class="col-12 p-0 pb-3">
                <p class="text-left mb-0">{data.label}</p>
              </div>

              {data["groupData"].map((gdata, key) => {
                gdata["parrentMode"] = data.mode;
                gdata["parrentName"] = data.name;

                if (gdata.type === "checkbox") {
                  if (gdata.readonly) {
                    if (gdata.value) {
                      return (
                        <div className="row pb-3">
                          <div className="col-2">
                            <div class="form-check q-check w-100">
                              <label className="checked">
                                <span>{gdata.label}</span>
                              </label>
                            </div>
                          </div>
                          <div className="col-10">
                            <div className="row">
                              {gdata["subgroupData"].map((gdata1, key) => {
                                return (
                                  <div
                                    className={`col-6 my-auto order-${key + 2}`}
                                  >
                                    <p className="form-control mb-0 readonly">
                                      {gdata1.value}
                                    </p>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      );
                    } else {
                      return (
                        <div className="row pb-3">
                          <div class="form-check q-check w-100">
                            {gdata.value}
                          </div>
                        </div>
                      );
                    }
                  } else {
                    return (
                      <div className="row pb-4">
                        <div class="col-2">
                          <div class="form-check q-check w-100">
                            <CheckboxLayer
                              selectdata={gdata}
                              {...this.props}
                              {...this.state}
                              key={data.name}
                              onselectChanges={this.selectChanges.bind(this)}
                            />
                          </div>
                        </div>
                        <div className="col-10">
                          <div className="row">
                            {gdata["subgroupData"].map((gdata1, key) => {
                              gdata1["parrentMode"] = data.mode;
                              gdata1["parrentName"] = data.name;
                              gdata1["childMode"] = gdata1.mode;
                              gdata1["childName"] = gdata1.name;
                              if (gdata1.type === "time") {
                                if (gdata1.readonly) {
                                  return (
                                    <div
                                      className={`col-6 my-auto order-${
                                        key + 2
                                      }`}
                                    >
                                      <p className="form-control mb-0 readonly">
                                        {gdata1.value}
                                      </p>
                                    </div>
                                  );
                                } else {
                                  return (
                                    <div
                                      key={key}
                                      className={`col-6 my-auto order-${
                                        key + 2
                                      }`}
                                    >
                                      <TimepickerLayer
                                        selectdata={gdata1}
                                        {...this.props}
                                        {...this.state}
                                        stepTime={1}
                                        key={data.name}
                                        onselectChanges={this.selectChanges.bind(
                                          this
                                        )}
                                      />
                                      {gdata1.errors.map((err, key) => {
                                        return (
                                          <small
                                            className="text-danger"
                                            key={key}
                                          >
                                            {err.message}
                                          </small>
                                        );
                                      })}
                                    </div>
                                  );
                                }
                              }
                            })}
                          </div>
                        </div>
                      </div>
                    );
                  }
                }
                  data.errors.map((err, key) => {
                    return (
                      <small
                        className="text-danger col-12 order-6 mt-2"
                        key={key}
                      >
                        {err.message}
                      </small>
                    );
                  });
              })}
              {data.errors.map((err, key) => {
                return (
                  <small className="text-danger col-12 mt-2" key={key}>
                    {err.message}
                  </small>
                );
              })}
            </div>
          </div>
        </React.Fragment>
      );
    }

    if (data.mode === "group" && data.type === "radio") {
      return (
        <div
          className={`${
            data.styles
              ? data.styles.cols
                ? data.styles.cols
                : "row my-4 w-100"
              : "row my-4 w-100"
          }`}
        >
          <div className="row h-100 w-100 align-item-center">
            <div
              class={`${
                data.styles
                  ? data.styles.label_cols
                    ? data.styles.label_cols
                    : "col-2"
                  : "col-2"
              } pr-0`}
            >
              <p class="text-left mb-0">{data.label}</p>
            </div>

            {data["groupData"].map((gdata, key) => {
              data["groupData"][key]["parrentMode"] = data.mode;
              data["groupData"][key]["parrentName"] = data.name;
            })}

            <div class="col pl-0">
              <InputRadiolayer
                selectdata={data["groupData"]}
                {...this.props}
                {...this.state}
                parrent_value={data.value}
                key={data.name}
                onselectChanges={this.selectChanges.bind(this)}
              />
            </div>
            {data.errors.map((err, key) => {
              return (
                <small className="text-danger col-12 mt-2" key={key}>
                  {err.message}
                </small>
              );
            })}
          </div>
        </div>
      );
    }
  }

  render() {
    return (
      <form>
        <div className="form-row my-4">
          {this.props.Queuedata.map((data, key) => {
            return this.renderInput(data, key);
          })}
        </div>
      </form>
    );
  }
}

export default QueuesListFormComponent;
